import { useEffect, useState } from "react";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { supabase } from "@/integrations/supabase/client";

const css = `
.notification-banner {
  position: fixed;
  top: calc(env(safe-area-inset-top, 0px) + 60px);
  left: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 20px;
  background: rgba(30, 30, 35, 0.85);
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2);
  z-index: 2000;
  animation: slideDownBanner 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
@keyframes slideDownBanner {
  from { opacity: 0; transform: translateY(-20px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.notif-icon {
  width: 38px; height: 38px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(59,130,246,0.25); font-size: 20px;
}
.notif-text { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.notif-text strong { font-size: 14px; color: white; font-weight: 600; }
.notif-text span   { font-size: 12px; color: rgba(255,255,255,0.6); }
.notif-allow {
  background: rgba(59,130,246,0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 10px;
  padding: 7px 14px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  transition: transform 0.15s ease;
}
.notif-allow:active { transform: scale(0.94); }
.notif-dismiss {
  background: none; border: none;
  color: rgba(255,255,255,0.4);
  font-size: 16px; cursor: pointer; padding: 4px;
}
`;

const DISMISS_KEY = "tecly:notif-banner-dismissed";

export const NotificationBanner = () => {
  const { isSupported, subscribe } = usePushNotifications();
  const [show, setShow] = useState(false);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setAuthed(!!data.user));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setAuthed(!!s?.user));
    return () => sub.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!isSupported || !authed) return;
    if (typeof Notification === "undefined") return;
    if (Notification.permission !== "default") return;
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    const t = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(t);
  }, [isSupported, authed]);

  if (!show) return null;

  const onAllow = async () => {
    await subscribe();
    setShow(false);
  };

  const onDismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  return (
    <>
      <style>{css}</style>
      <div className="notification-banner" role="dialog" aria-label="Attiva notifiche">
        <div className="notif-icon">🔔</div>
        <div className="notif-text">
          <strong>Resta aggiornato</strong>
          <span>Ricevi le ultime news Apple in tempo reale</span>
        </div>
        <button className="notif-allow btn-liquid" onClick={onAllow}>Consenti</button>
        <button className="notif-dismiss" onClick={onDismiss} aria-label="Chiudi">✕</button>
      </div>
    </>
  );
};

export default NotificationBanner;
